<div *ngIf="isLoadingEngagementStats" class="loading-container">
	<qai-loading [size]="'medium'"></qai-loading>
</div>


<div class="container" *ngIf="isTranslationLoaded && !isLoadingEngagementStats">
	<div class="stats">
		<qai-reporting-card [class.attempts-card]="hasOutOfAttempts" 
			[title]="outOfAttemptsCardTitle | transloco" 
			[value]="outOfAttemptsCardValue" 
			align="start">
		</qai-reporting-card>
		<qai-reporting-card [title]="'reportingV2.TRAINER_TIME_SAVED' | transloco"
			[value]="formatTotalDuration(engagementStats?.totalDurationInSeconds || 0)"
			align="start"></qai-reporting-card>
		<qai-reporting-card [title]="'reportingV2.PERCENT_CERTIFIED' | transloco"
			[value]="localeService.formatPercentage(engagementStats?.percentCompleted || 0, localeService.getDecimalPlaces(engagementStats?.percentCompleted || 0, 2))"
			align="start"></qai-reporting-card>
		<qai-reporting-card [title]="'reportingV2.PERCENT_CERTIFIED_FIRST_ATTEMPT' | transloco"
			[value]="localeService.formatPercentage(engagementStats?.percentCertifiedFirstTry || 0, localeService.getDecimalPlaces(engagementStats?.percentCertifiedFirstTry || 0, 2))"
			align="start"></qai-reporting-card>
	</div>
	<div class="donut-container">
		<div #donutChartContainer class="donut-chart-container"></div>
	</div>
</div>